import React from "react";
import * as moment from "moment";
import { NavLink } from "react-router-dom";

import { getImageURL } from "../../utils/functions";

const Blog = ({ blogPosts, assets }) => (
  <section className="recent-news owl_custom_nav ls ms s-py-60 s-py-md-90 s-py-xl-120 c-gutter-60 text-center text-md-left">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-md-8 col-lg-10">
              <h4 className="special-heading underline">
                Resources
              </h4>
            </div>
            <div className="d-none d-md-block col-sm-4 col-lg-2">
              <NavLink to="/resources">
                <a className="btn btn-square ml-auto">
                  {" "}
                  All
                  <br />
                  Resources
                </a>
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-12 ">
          <div className="widget widget_slider widget_slider_title">
            <div className="divider-40"></div>
            <div className="blog-items top-right-nav">
              {blogPosts.map(({ fields, sys }, index) => {
                const { title, publishDate, heroImage, description } = fields;

                return (
                  <div
                    key={`home-blog-${index}`}
                    className="vertical-item box-shadow"
                  >
                    <div className="item-media">
                      <img
                        src={getImageURL(assets, heroImage.sys.id)}
                        alt="img"
                      />
                    </div>
                    <div className="item-content">
                      <header className="entry-header">
                        <h6>
                          <NavLink to={`resources/article/${sys.id}`}>
                            <a rel="bookmark">{title}</a>
                          </NavLink>
                        </h6>
                        <p
                          dangerouslySetInnerHTML={{ __html: description }}
                        ></p>
                      </header>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="divider-45"></div>
        </div>
      </div>
    </div>
  </section>
);

export default Blog;
